import 'babel-polyfill';
import 'innersvg-polyfill/innersvg';
import Vue from 'vue';
import vClickOutside from 'v-click-outside';
import VTooltip from 'v-tooltip';

import { createApp } from '@/create-app';
import { setupTracking } from '@/tracking';

Vue.use(vClickOutside);
Vue.use(VTooltip, {
  defaultClass: 'x-tooltip',
  defaultArrowSelector: '.x-tooltip-arrow',
  defaultInnerSelector: '.x-tooltip-inner',
  defaultTemplate: '<div class="x-tooltip" role="tooltip"><div class="x-tooltip-arrow"></div><div class="x-tooltip-inner" selenium="tooltip"></div></div>',
});

const context = window.__SERVER_CTX__;

const { ready, vm } = createApp(context);
setupTracking({ events: vm.$events, context });

ready.then(() => {
  // actually mount to DOM
  vm.$mount('#app');
});
